import { BaseAPIModel, fetcher } from '@weezevent/weezjs-core';
export default class InvoicingModel extends BaseAPIModel {
    fields() {
        return {
            etat: {},
            etat_hl: {},
            societe: {},
            forme: {},
            siret: {},
            siret_lieu: {},
            tva_intra: {},
            adresse: {},
            cp: {},
            province: {},
            ville: {},
            pays: {},
            divers: {},
            telephone: {},
            email: {}
        };
    }

    /**
     * Save item to API
     */
    save(...args) {
        return this.constructor.save(this, ...args);
    }

    static save(objects, ...args) {
        let data = objects.toAPI();
        let url = this.getListUrl(...args);

        return fetcher.patch(url, { data });
    }

    static list(item) {
        return item;
    }

    static listUrl({ organizationId, eventId }) {
        return `/ticket/organizations/${organizationId}/events/${eventId}/invoicing`;
    }
}
